/**
 * Parse and format dates safely
 * Handles various date formats (ISO 8601, timestamps, etc.)
 */
export function formatDate(dateString, options = {}) {
  if (!dateString) return 'Fecha no disponible';

  try {
    // Handle various date formats
    let date;

    // If it's already a Date object
    if (dateString instanceof Date) {
      date = dateString;
    } else if (typeof dateString === 'string') {
      // Trim whitespace
      const trimmed = dateString.trim();

      // Try parsing ISO format directly
      date = new Date(trimmed);

      // If parse failed or resulted in Invalid Date, try alternatives
      if (isNaN(date.getTime())) {
        // Remove 'Z' timezone indicator and parse as local
        const cleanDate = trimmed.replace('Z', '').split('T')[0];
        date = new Date(cleanDate + 'T00:00:00');
      }

      // Still invalid? Try split by space (handle formats like "2026-03-04 14:30:00")
      if (isNaN(date.getTime())) {
        const [datePart] = trimmed.split(' ');
        date = new Date(datePart + 'T00:00:00');
      }
    } else {
      return 'Fecha no válida';
    }

    // Check if still invalid
    if (isNaN(date.getTime())) {
      console.warn('Invalid date string:', dateString);
      return 'Fecha inválida';
    }

    const { locale = 'es-ES', format = 'short' } = options;

    if (format === 'short') {
      return date.toLocaleDateString(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    } else if (format === 'long') {
      return date.toLocaleDateString(locale, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } else if (format === 'time') {
      return date.toLocaleTimeString(locale, {
        hour: '2-digit',
        minute: '2-digit',
      });
    } else if (format === 'datetime') {
      return date.toLocaleString(locale, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    }

    return date.toLocaleDateString(locale);
  } catch (error) {
    console.error('Error formatting date:', error, dateString);
    return 'Fecha no disponible';
  }
}

export default formatDate;
